import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { element } from 'protractor';
import { GlobalService } from 'src/app/_services/global.service';
import { DataService } from 'src/app/dashboard/_services/data.service';
import { StudentService } from 'src/app/user-management/_services/student.service';
import { ErrorMsgService } from '../../error-msg/error-msg.service';
import { StaffService } from 'src/app/school-management/_services/staff.service';
import * as XLSX from 'xlsx-js-style';
import { UploadService } from 'src/app/user-management/_services/upload.service';
declare var $: any;

@Component({
  selector: 'app-field-correction-revamp',
  templateUrl: './field-correction-revamp.component.html',
  styleUrls: ['./field-correction-revamp.component.scss']
})
export class FieldCorrectionRevampComponent implements OnInit {

  currLang;
  nameTagCards: any = [];
  filesErrorKeys = [];
  fileErrors = []
  skippedErrors = [] // Track errors that have been skipped
  progress: number = 0;
  completedErrors: number = 0;
  originalErrorsLength: number;
  switchGradesDropdown: boolean = false;
  selectedGradeindex: number = 0;
  selectedClassName: string = '';
  selectedClassId: number;
  grades = [];
  user = {
    name: '',
    national_id: '',
    gender: '',
    role_type: '',
    country_code: '',
    phone: '',
    email: '',
  }
  student = {
    name: '',
    national_id: '',
    gender: '',
    grade_name: '',
    class_name: '',
    grade_id: null,
    class_id: null,
    create_grade_and_class: ''
  }

  parent = {
    name: '',
    gender: '',
    national_id: '',
    country_code: '',
    phone: '',
    type: '',
    email: ''
  }

  loading = true;
  showConfirmationModal = false;

  @Input() uploadErrors;
  @Input() userRole;



  constructor(
    private dataService: DataService,
    private globalService: GlobalService, private translate: TranslateService, private router: Router,
    private studentService: StudentService,
    private errorMsgService: ErrorMsgService,
    private staffService: StaffService,
    private uploadService: UploadService,
  ) { }

  ngOnInit(): void {
    // to remove the black screen and the stuck error msg popup if error message was just closed in sibling component
    $(".modal").modal("hide");
    $("body").removeClass("modal-open");
    $(".modal-backdrop").remove();
    this.showConfirmationModal = false;
    this.globalService.getLang().subscribe(lng => {
      this.currLang = lng;
      this.translate.use(this.currLang);
    });

    setTimeout(() => {
      this.mapErrors();

    }, 1000);
    this.translate.get('init').subscribe(res => {
    });
    this.translate.onLangChange.subscribe(res => {
      this.currLang = res.lang;
    });

  }

  mapErrors() {
    let count = 0;
    this.fileErrors = this.uploadErrors;
    this.fileErrors.map(fileError => {
      fileError.count = count;
      fileError.fileErrorKeys = Object.keys(fileError.invalid);
      fileError.selected = false;
      count++;
    })
    this.fileErrors[0].selected = true;
    // to get the original error length on init for progress bar
    this.originalErrorsLength = this.fileErrors.length;

    this.loading = false;
  }

  selectError(error, saveNext: boolean) {
    let errorIndex;
    this.fileErrors.forEach(err => {
      err.selected = false;
    })

    errorIndex = this.fileErrors.indexOf(error);
    /* check if this erorr is the last one in the array , 
    then make it's index -1 so that when we click save and next 
    we increment by one so the index becomes 0 which is the first element of the array */
    errorIndex = errorIndex == this.fileErrors.length - 1 ? -1 : errorIndex

    switch (saveNext) {
      // if the user clicked on save and next
      case true:
        // check if the errors array still have atleast one error before we apply the logic
        if (this.fileErrors.length > 0) {
          error.selected = true;

          this.addUser(error, errorIndex)
        }
        break;
      // if the user clicked on the card info itself
      case false:
        error.selected = true;
        break;

      default:
        break;
    }
  }

  skipError(error, index: number) {
    // Add the error to skippedErrors array before removing it
    this.skippedErrors.push(error);
    
    this.fileErrors = this.fileErrors.filter(err => err !== error);

    this.completedErrors++;
    this.progress = Math.round(((this.completedErrors / this.originalErrorsLength) * 100) * 10) / 10;

    if (this.fileErrors.length > 0) {
        let nextIndex = index >= this.fileErrors.length ? 0 : index;
        this.fileErrors[nextIndex].selected = true;
    }

    // Check if progress is 100% and there are skipped errors
    if (this.progress == 100 && this.skippedErrors.length > 0) {
      // Show confirmation modal instead of automatically hiding
      this.showConfirmationModal = true;
    } else {
      this.uploadService.sendfieldCorrectionProgress(this.progress);
    }
}

  progressLocalization(progress?) {
    let percentage: any;
    percentage = this.currLang == "en" ? progress.toLocaleString('en-US') : progress.toLocaleString('ar-EG')
    return percentage;
  }

  reselectGradesClasses() {
    this.dataService.getAllGrades().subscribe(res => {
      this.grades = [... this.grades, ...res.filter(grades => grades.school_classes.length != 0)];
      this.grades = [...new Map(this.grades.map(item => [item['name'], item])).values()];
      this.selectedClassId = this.grades[this.selectedGradeindex]?.school_classes[0]?.id;
      this.selectedClassName = this.grades[this.selectedGradeindex]?.school_classes[0]?.name;
      this.switchGradesDropdown = true;
    })
  }

  setGrade() {
    this.selectedClassId = this.grades[this.selectedGradeindex]?.school_classes[0]?.id;
  }

  addUser(error, index) {
    this.loading = true;
    const formData = new FormData();

    switch (this.userRole) {
      case "students":
        let student = {
          name: '',
          national_id: '',
          gender: '',
          grade_name: '',
          class_name: '',
          grade_id: null,
          class_id: null,
          create_grade_and_class: ''
        }

        let parent = {
          name: '',
          gender: '',
          national_id: '',
          country_code: '',
          phone: '',
          email: ''
        }
        // replace any null value with empty string
        Object.keys(error.values).forEach(key => {
          error.values[key] = error.values[key] == null ? '' : error.values[key]
        });
        
        student.name = error.values.name;
        student.national_id = error.values.national_id;
        student.gender =this.textFormattting(error.values.gender);
        student.grade_name = error.values.grade_name;
        student.class_name = error.values.class_name;
        student.create_grade_and_class = error.values.create_grade_and_class;
        parent.name = error.values.parent_name;
        parent.national_id = error.values.parent_national_id;
        parent.gender = this.textFormattting(error.values.parent_gender);
        parent.country_code = error.values.parent_country_code;
        parent.phone = error.values.parent_phone;
        // parent.type = error.values.parent_type;
        parent.email = error.values.parent_email;
        if (this.switchGradesDropdown) {
          delete student.class_name
          delete student.grade_name
          student.grade_id = this.grades[this.selectedGradeindex].id;
          student.class_id = this.selectedClassId;
        }
        else {
          delete student.class_id
          delete student.grade_id
        }
        if (student.create_grade_and_class || student.create_grade_and_class == undefined) {
          delete student.create_grade_and_class;
        }

        for (const i in student) {
          formData.append(i, student[i])
        }
        for (const i in parent) {
          formData.append(`parent[${i}]`, parent[i])
        }


        this.studentService.addStudent(formData).subscribe(res => {
        }, (err) => {
          if (err.error.errors) {
            error.invalid = err.error.errors
            error.fileErrorKeys = Object.keys(error.invalid);
          }

          else {
            this.errorMsgService.setMessage(err.error.message);
          }
          this.loading = false;
        }, () => {
          // when we click save and next we use the current error index +1 to select the next error 
          this.fileErrors[index + 1].selected = true;
          /* we increment the comleted errors variable by 1 on ever succesful submition of errors , 
             we use this var to track how many succesful error submitions the user have done
             we use this var for the progress bar*/
          this.completedErrors++
          /*
          we calculate the percentage of completion by deviding 
          the completed over the total (the original errors lengh) and multiply by 100
          we use the round of this value multiplied by 10 then we devide over 10 to get on decimal values
           */
          this.progress = Math.round(((this.completedErrors / this.originalErrorsLength) * 100) * 10) / 10;
          /* then we filter the succesful submited errors from the errors array ,
          thats why we track the original errors length on init and not in the scope of this method 
          as we need the original lengh for progress bar 
           */
          this.fileErrors = this.fileErrors.filter(errz => errz != error)
          // Check if progress is 100% and there are skipped errors
          if (this.progress == 100 && this.skippedErrors.length > 0) {
            // Show confirmation modal instead of automatically hiding
            this.showConfirmationModal = true;
          } else {
            // send the progress to the upload component so when the progress is 100% we hide the fields correction cards
            this.uploadService.sendfieldCorrectionProgress(this.progress);
          }

          this.loading = false;
        })
        break;

      case "staff":
        let staff = {
          name: '',
          national_id: '',
          gender: '',
          role_type: '',
          country_code: '',
          phone: '',
          email: '',
        }
         // replace any null value with empty string
        Object.keys(error.values).forEach(key => {
          error.values[key] = error.values[key] == null ? '' : error.values[key]
        });

        staff.name = error.values.name;
        staff.national_id = error.values.national_id;
        staff.gender = this.textFormattting(error.values.gender);
        staff.email = error.values.email;
        staff.phone = error.values.phone;
        staff.role_type = error.values.role_type;
        staff.country_code = error.values.country_code;


        for (const i in staff) {
          formData.append(i, staff[i])
        }

        this.staffService.addStaff(formData).subscribe(res => {
        }, (err) => {
          if (err.error.errors) {
            error.invalid = err.error.errors
            error.fileErrorKeys = Object.keys(error.invalid);
          }

          else {
            this.errorMsgService.setMessage(err.error.message);
          }
          this.loading = false;
        }, () => {
          // when we click save and next we use the current error index +1 to select the next error 
          this.fileErrors[index + 1].selected = true;
          /* we increment the comleted errors variable by 1 on ever succesful submition of errors , 
             we use this var to track how many succesful error submitions the user have done
             we use this var for the progress bar*/
          this.completedErrors++
          /*
          we calculate the percentage of completion by deviding 
          the completed over the total (the original errors lengh) and multiply by 100
          we use the round of this value multiplied by 10 then we devide over 10 to get on decimal values
           */
          this.progress = Math.round(((this.completedErrors / this.originalErrorsLength) * 100) * 10) / 10;
          /* then we filter the succesful submited errors from the errors array ,
          thats why we track the original errors length on init and not in the scope of this method 
          as we need the original lengh for progress bar 
           */
          this.fileErrors = this.fileErrors.filter(errz => errz != error)
          // Check if progress is 100% and there are skipped errors
          if (this.progress == 100 && this.skippedErrors.length > 0) {
            // Show confirmation modal instead of automatically hiding
            this.showConfirmationModal = true;
          } else {
            // send the progress to the upload component so when the progress is 100% we hide the fields correction cards
            this.uploadService.sendfieldCorrectionProgress(this.progress);
          }
          this.loading = false;
        })

        break;

      default:
        break;
    }

  }


  /**
   * Build a human-readable, comma-separated summary of all validation errors
   * for a single record, e.g. "gender: Invalid gender, national_id: Already exists".
   * Reads from error.invalid, where each key is a field and the value is a
   * message (or array of messages).
   */
  buildErrorsSummary(error: any): string {
    if (!error || !error.invalid) {
      return '';
    }
    return Object.keys(error.invalid)
      .map(field => {
        const messages = error.invalid[field];
        const message = Array.isArray(messages) ? messages.join('; ') : messages;
        // Normalize the field key to match the exported column titles
        // (invalid keys are dotted like "parent.national_id", columns are
        // underscored like "parent_national_id").
        const columnTitle = field.replace(/\./g, '_');
        return `${columnTitle}: ${message}`;
      })
      .join('\n');
  }

  // Top "Download" button: export only the error rows still in the correction
  // list (not yet fixed and not skipped).
  exportToExcelFile() {
    this.generateExcel(this.fileErrors);
  }

  private generateExcel(errorRecords: any[]) {
    let workBook = XLSX.utils.book_new();
    workBook.SheetNames.push('test sheet');

    // Each row = its original values plus an "Errors" column summary
    let valuesToBeExported = errorRecords.map(errorRecord => ({
      ...errorRecord.values,
      Errors: this.buildErrorsSummary(errorRecord)
    }));

    let ws_Data = valuesToBeExported;
    let ws = XLSX.utils.json_to_sheet(ws_Data);

    // Find the "Errors" column and style the sheet:
    // - every cell is vertically centered so tall (multi-line) rows look aligned
    // - the "Errors" column wraps text so each error shows on its own line
    const range = XLSX.utils.decode_range(ws['!ref']);
    let errorsCol = -1;
    for (let col = range.s.c; col <= range.e.c; col++) {
      const headerCell = ws[XLSX.utils.encode_cell({ r: range.s.r, c: col })];
      if (headerCell && headerCell.v === 'Errors') {
        errorsCol = col;
        // Give the Errors column some width so the wrapped lines are readable.
        ws['!cols'] = ws['!cols'] || [];
        ws['!cols'][col] = { wch: 50 };
      }
    }
    for (let row = range.s.r; row <= range.e.r; row++) {
      for (let col = range.s.c; col <= range.e.c; col++) {
        const cell = ws[XLSX.utils.encode_cell({ r: row, c: col })];
        if (cell) {
          cell.s = {
            ...(cell.s || {}),
            alignment: { vertical: 'center', wrapText: col === errorsCol }
          };
        }
      }
    }

    workBook.Sheets['test sheet'] = ws;
    // writeFile triggers the browser download directly.
    XLSX.writeFile(workBook, 'book.xlsx');
  }

  // Handle download action from confirmation modal: export the skipped rows.
  downloadSkippedErrors() {
    this.generateExcel(this.skippedErrors);
    this.hideComponent();
  }

  // Handle cancel action from confirmation modal
  cancelAndHideComponent() {
    this.hideComponent();
  }

  // Common method to hide the component
  private hideComponent() {
    this.showConfirmationModal = false;
    this.uploadService.sendfieldCorrectionProgress(this.progress);
  }

  updateSystemApis() {
    if (this.userRole == "students") {
      this.globalService.startInitialLoading();
      this.dataService.updateGradesCache$().subscribe(() => {
        this.globalService.stopInitialLoading();
      })
    }
  }

  textFormattting(text){
    text=text.trim().toLowerCase();
    return text
  }

  ngOnDestroy() {
    this.updateSystemApis();
  }

}
